"use client";
import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import a from "../components/Icon/SvgIcon.js";
const c = (l) => /* @__PURE__ */ r(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M12.013 2h.002a.62.62 0 0 1 .48.224l4.887 5.767a.625.625 0 1 1-.954.808L12.64 4.33V16.5a.625.625 0 1 1-1.25 0V4.327L7.601 8.789a.625.625 0 0 1-.952-.808l4.887-5.757.06-.063A.63.63 0 0 1 12.013 2"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M2.625 14.515c.345 0 .625.28.625.625v4.23c0 .743.635 1.385 1.458 1.385h14.584c.825 0 1.458-.644 1.458-1.375v-4.24a.625.625 0 1 1 1.25 0v4.24c0 1.469-1.242 2.625-2.708 2.625H4.708C3.24 22.005 2 20.847 2 19.37v-4.23c0-.345.28-.625.625-.625"
        }
      )
    ]
  }
), i = t(c);
export {
  i as Upload,
  i as default
};
